import { Button, Card, Col, Table, theme } from 'antd'
import React from 'react'
import CustomRow from '../../../reusable-components/CustomRow'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { hexToRGBA } from '../../../lib/utils'

const MealSummary = ({
  general,
  dietaryPreferences,
  mealSchedule,
  nutritionalGoals,
  recipes,
  shoppingList,
  educationalResources,
  isMonitoring,
  setCurrentStep,
  planType,
  planLabel
}) => {
  const { token } = theme.useToken()

  // Display the correct plan type in UI
  const displayLabel = planLabel || 'Meal Plan'

  return (
    <Card size='small'>
      <CustomRow>
        <Col span={8}>
          <Card
            headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
            size='small'
            title='General Information'
            extra={
              <Button type='primary' onClick={() => setCurrentStep(0)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            }
          >
            <h1>{general.name || <span style={{ color: token.colorError }}>NO NAME PROVIDED</span>} </h1>
            <p>{general.description || <span style={{ color: token.colorError }}>No description provided</span>} </p>
          </Card>
        </Col>
        <Col span={16}>
          <Card
            title='Dietary Preferences'
            headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
            size='small'
            extra={
              <Button type='primary' onClick={() => setCurrentStep(1)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            }
          >
            {dietaryPreferences.length === 0 ? (
              <p style={{ color: token.colorError }}>No dietary preferences added.</p>
            ) : (
              <Table
                size='small'
                pagination={false}
                showHeader={false}
                columns={[{ title: 'Diet Type', dataIndex: 'dietType' }]}
                dataSource={dietaryPreferences}
              />
            )}
          </Card>

          <Card
            title='Meal Schedule'
            style={{ marginTop: 12 }}
            headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
            size='small'
            extra={
              <Button type='primary' onClick={() => setCurrentStep(2)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            }
          >
            {mealSchedule.length === 0 ? (
              <p style={{ color: token.colorError }}>No meal schedule added.</p>
            ) : (
              <Table
                size='small'
                pagination={false}
                showHeader={false}
                columns={[{ title: 'Meal Type', dataIndex: 'mealType' }]}
                dataSource={mealSchedule}
              />
            )}
          </Card>

          <Card
            title='Nutritional Goals'
            style={{ marginTop: 12 }}
            headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
            size='small'
            extra={
              <Button type='primary' onClick={() => setCurrentStep(3)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            }
          >
            {nutritionalGoals.length === 0 ? (
              <p style={{ color: token.colorError }}>No nutritional goals added.</p>
            ) : (
              <Table
                size='small'
                pagination={false}
                showHeader={false}
                columns={[{ title: 'Goal Type', dataIndex: 'goalType' }]}
                dataSource={nutritionalGoals}
              />
            )}
          </Card>

          <Card
            title='Recipes'
            style={{ marginTop: 12 }}
            headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
            size='small'
            extra={
              <Button type='primary' onClick={() => setCurrentStep(4)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            }
          >
            {recipes.length === 0 ? (
              <p style={{ color: token.colorError }}>No recipes added.</p>
            ) : (
              <Table
                size='small'
                pagination={false}
                showHeader={false}
                columns={[{ title: 'Recipe', dataIndex: 'name' }]}
                dataSource={recipes}
              />
            )}
          </Card>

          <Card
            title='Shopping List'
            style={{ marginTop: 12 }}
            headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
            size='small'
            extra={
              <Button type='primary' onClick={() => setCurrentStep(5)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            }
          >
            {shoppingList.length === 0 ? (
              <p style={{ color: token.colorError }}>No shopping items added.</p>
            ) : (
              <Table
                size='small'
                pagination={false}
                showHeader={false}
                columns={[{ title: 'Item', dataIndex: 'name' }]}
                dataSource={shoppingList}
              />
            )}
          </Card>

          <Card
            title='Educational Resources'
            style={{ marginTop: 12 }}
            headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
            size='small'
            extra={
              <Button type='primary' onClick={() => setCurrentStep(6)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            }
          >
            {educationalResources.length === 0 ? (
              <p style={{ color: token.colorError }}>No educational resources added.</p>
            ) : (
              <Table
                size='small'
                pagination={false}
                showHeader={false}
                columns={[{ title: 'Resource', dataIndex: 'title' }]}
                dataSource={educationalResources}
              />
            )}
          </Card>
        </Col>
      </CustomRow>
    </Card>
  )
}

export default MealSummary
